/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAirport = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m0 2 1 6v3a6.002 6.002 0 0 0 4.765 5.873L4 22h4.904l4.589-5H19a5 5 0 0 0 5-5 5 5 0 0 0-5-5H9.661l-4-5zm2.361 2H4.7l2.4 3H2.861zM3 11V9h16a3 3 0 0 1 0 6h-3.672L19 11H7.786l-1.362 3.959A4 4 0 0 1 3 11zm6.205 2H14l-5.88 7H7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAirport as Airport };
